import { useEffect, useState } from 'react';

import { getQuickAccessContent } from 'services/api';
import { QuickAccessData } from 'services/api/quick-access-content/types';

export const useQuickAcces = () => {
  const [quickAccesContent, setQuickAccesContent] = useState<QuickAccessData>();

  useEffect(() => {
    getQuickAccessContent(window.location.origin, '37966').then((result) => setQuickAccesContent(result));
  }, []);

  return { quickAccesContent };
};
